const admission = [{
  path: 'admission/index',
  component: resolve => require(['../../../../components/pages/user/admission'], resolve)
}]

export default admission



// WEBPACK FOOTER //
// ./src/router/pages/user/admission/index.js